import { todayYmd, shiftYmd, uid } from './demoStore';

function buildWeightSeries(base = 72.5) {
  const today = todayYmd();
  return Array.from({ length: 14 }, (_, i) => {
    const fecha = shiftYmd(today, i - 13);
    const wobble = Math.sin(i / 2) * 0.4 + (i % 3) * 0.15;
    return {
      fecha,
      label: fecha.slice(5),
      peso: Math.round((base - i * 0.12 + wobble) * 10) / 10,
    };
  });
}

function buildLoadSeries(base = 42) {
  const today = todayYmd();
  return Array.from({ length: 8 }, (_, i) => {
    const fecha = shiftYmd(today, (i - 7) * 2);
    return {
      fecha,
      label: fecha.slice(5),
      carga: base + i * 2.2 + (i % 2) * 1.2,
      reps: 10 - (i % 3),
    };
  });
}

function dayTemplate(nombre, exercises) {
  return {
    dia: 1,
    nombre,
    session_kind: 'gym',
    ejercicios: exercises.map((ex, i) => ({
      id: `ex_${i}`,
      exercise_name: ex.name,
      sets: ex.sets,
      reps: ex.reps,
      rest_seconds: ex.rest || 90,
      intensity_type: 'RPE',
      intensity_value: ex.rpe || 7,
      notes: '',
    })),
  };
}

/** Rutinas prediseñadas (biblioteca coach), como en Editar rutinas → Rutinas. */
export const PREDESIGNED_ROUTINES = [
  {
    id: 'tpl_full_body_a',
    nombre: 'Full Body A · Principiante',
    level: 'principiante',
    method: 'hipertrofia',
    is_template: true,
    prediseñada: true,
    dias: [
      dayTemplate('Día 1 · Full Body', [
        { name: 'Sentadilla goblet', sets: 3, reps: '10-12', rpe: 6 },
        { name: 'Press banca mancuernas', sets: 3, reps: '8-10', rpe: 7 },
        { name: 'Remo unilateral', sets: 3, reps: '10-12', rpe: 7 },
        { name: 'Plancha', sets: 3, reps: '30s', rpe: 6 },
      ]),
    ],
  },
  {
    id: 'tpl_upper_inter',
    nombre: 'Upper hipertrofia · Intermedio',
    level: 'intermedio',
    method: 'hipertrofia',
    is_template: true,
    prediseñada: true,
    dias: [
      dayTemplate('Día 1 · Upper', [
        { name: 'Press banca', sets: 4, reps: '6-8', rpe: 8 },
        { name: 'Remo con barra', sets: 4, reps: '8-10', rpe: 8 },
        { name: 'Press militar', sets: 3, reps: '8-10', rpe: 7 },
        { name: 'Face pull', sets: 3, reps: '12-15', rpe: 6 },
      ]),
    ],
  },
  {
    id: 'tpl_fuerza_lower',
    nombre: 'Lower fuerza · Avanzado',
    level: 'avanzado',
    method: 'fuerza',
    is_template: true,
    prediseñada: true,
    dias: [
      dayTemplate('Día 1 · Lower', [
        { name: 'Sentadilla trasera', sets: 5, reps: '3-5', rpe: 8, rest: 180 },
        { name: 'Peso muerto rumano', sets: 4, reps: '5-6', rpe: 8, rest: 150 },
        { name: 'Zancadas', sets: 3, reps: '8-10', rpe: 7 },
        { name: 'Elevación de gemelos', sets: 4, reps: '10-12', rpe: 7 },
      ]),
    ],
  },
];

function seedClients() {
  const today = todayYmd();
  return [
    {
      id: 'cli_maria',
      nombre: 'María López',
      email: 'maria.demo@ejemplo.com',
      telefono: '3001112233',
      plan: 'Mensual Training',
      traffic_light: 'green',
      adherence_pct: 86,
      has_plan: true,
      assigned_routine_id: 'tpl_upper_inter',
      last_session: shiftYmd(today, -1),
      weight_series: buildWeightSeries(68.2),
      load_series: buildLoadSeries(48),
      sessions: [
        { id: 's1', fecha: shiftYmd(today, -1), titulo: 'Upper A', completado: true, volumen: 8200 },
        { id: 's2', fecha: shiftYmd(today, -3), titulo: 'Lower B', completado: true, volumen: 9100 },
        { id: 's3', fecha: shiftYmd(today, -5), titulo: 'Upper B', completado: true, volumen: 7800 },
      ],
      wellbeing: { sueño: 8, estrés: 3, energía: 7 },
      athlete_day: {
        day_name: 'Día 1 · Upper A',
        exercises: [
          { id: 'ae1', nombre: 'Press banca', sets: 4, reps: '6-8', done: [true, true, false, false], load: 50 },
          { id: 'ae2', nombre: 'Remo con barra', sets: 4, reps: '8-10', done: [true, false, false, false], load: 45 },
          { id: 'ae3', nombre: 'Press militar', sets: 3, reps: '8-10', done: [false, false, false], load: 25 },
        ],
      },
    },
    {
      id: 'cli_juan',
      nombre: 'Juan Pérez',
      email: 'juan.demo@ejemplo.com',
      telefono: '3004445566',
      plan: 'Trimestral Training',
      traffic_light: 'yellow',
      adherence_pct: 54,
      has_plan: true,
      assigned_routine_id: 'tpl_full_body_a',
      last_session: shiftYmd(today, -4),
      weight_series: buildWeightSeries(81.4),
      load_series: buildLoadSeries(40),
      sessions: [
        { id: 's1', fecha: shiftYmd(today, -4), titulo: 'Full Body', completado: true, volumen: 5400 },
        { id: 's2', fecha: shiftYmd(today, -9), titulo: 'Full Body', completado: false, volumen: 2100 },
      ],
      wellbeing: { sueño: 5, estrés: 6, energía: 4 },
      athlete_day: {
        day_name: 'Día 1 · Full Body',
        exercises: [
          { id: 'ae1', nombre: 'Sentadilla goblet', sets: 3, reps: '10-12', done: [false, false, false], load: 20 },
          { id: 'ae2', nombre: 'Press banca mancuernas', sets: 3, reps: '8-10', done: [false, false, false], load: 18 },
        ],
      },
    },
    {
      id: 'cli_ana',
      nombre: 'Ana Ruiz',
      email: 'ana.demo@ejemplo.com',
      telefono: '',
      plan: 'Mensual Training',
      traffic_light: 'red',
      adherence_pct: 22,
      has_plan: false,
      assigned_routine_id: null,
      last_session: null,
      weight_series: buildWeightSeries(64),
      load_series: buildLoadSeries(30),
      sessions: [],
      wellbeing: { sueño: 4, estrés: 7, energía: 3 },
      athlete_day: {
        day_name: 'Sin rutina asignada',
        exercises: [],
      },
    },
  ];
}

function emptyFoodDay() {
  return {
    today_kcal: 920,
    today_protein: 68,
    today_carbs: 85,
    today_fat: 28,
    goal_kcal: 1800,
    goal_protein: 120,
    goal_carbs: 180,
    goal_fat: 55,
    meals: [
      { id: 'm1', name: 'Avena con frutas', meal: 'Desayuno', kcal: 320, protein: 12, carbs: 48, fat: 8 },
      { id: 'm2', name: 'Pollo + arroz', meal: 'Almuerzo', kcal: 480, protein: 42, carbs: 45, fat: 12 },
      { id: 'm3', name: 'Yogur griego', meal: 'Snack', kcal: 120, protein: 14, carbs: 8, fat: 4 },
    ],
    weight_series: buildWeightSeries(72.5),
    measure_series: [
      { label: 'Sep', peso: 74.8, pecho: 98, abdomen: 88 },
      { label: 'Oct 1', peso: 73.6, pecho: 97, abdomen: 86 },
      { label: 'Oct 15', peso: 72.9, pecho: 96, abdomen: 84 },
      { label: 'Hoy', peso: 72.5, pecho: 95, abdomen: 83 },
    ],
    water_glasses: 4,
    steps: 6200,
    plan: {
      meta: 'Bajar',
      peso: 72.5,
      altura: 168,
      edad: 32,
    },
    daily_report: {
      rendimiento: 7,
      motivacion: 8,
      hambre: 4,
      fatiga: 3,
      estres: 3,
      sueño: 7,
      animo: 8,
    },
  };
}

export const FOOD_QUICK_ADD = [
  { name: 'Huevos revueltos', meal: 'Desayuno', kcal: 220, protein: 18, carbs: 2, fat: 16 },
  { name: 'Ensalada atún', meal: 'Cena', kcal: 350, protein: 32, carbs: 12, fat: 18 },
  { name: 'Batido proteína', meal: 'Snack', kcal: 180, protein: 25, carbs: 8, fat: 3 },
  { name: 'Salmón + verduras', meal: 'Cena', kcal: 420, protein: 38, carbs: 18, fat: 22 },
];

export const FOOD_NAV_FINAL = [
  { id: 'dashboard', label: 'Dashboard' },
  { id: 'nutrition', label: 'Nutrición' },
  { id: 'chat', label: 'Chat Nico' },
  { id: 'plan', label: 'Mi Plan' },
  { id: 'measures', label: 'Medidas' },
  { id: 'report', label: 'Reporte Diario' },
  { id: 'recipes', label: 'Recetas del Chef' },
  { id: 'mytrainer', label: 'Mi Entrenador' },
  { id: 'profile', label: 'Perfil' },
];

/** Nav Food TRAINER (Layout.tsx). Sin Pendientes ni Sin ingreso: eso es de admin. */
export const FOOD_NAV_ENTRENADOR = [
  { id: 'panel', label: 'Panel' },
  { id: 'localmeals', label: 'Comidas habituales' },
  { id: 'vigencias', label: 'Vigencias' },
  { id: 'notifications', label: 'Notas' },
  { id: 'reminder', label: 'Recordatorio Medidas' },
  { id: 'profile', label: 'Perfil' },
];

export const DEMO_LOCAL_MEALS = [
  { id: 'lm1', restaurant: 'El Corral', name: 'Hamburguesa El Corral', meal: 'Almuerzo', kcal: 680, protein: 34, carbs: 52, fat: 36 },
  { id: 'lm2', restaurant: 'Crepes & Waffles', name: 'Ensalada César', meal: 'Almuerzo', kcal: 420, protein: 22, carbs: 18, fat: 28 },
  { id: 'lm3', restaurant: 'Crepes & Waffles', name: 'Crepes de pollo', meal: 'Cena', kcal: 540, protein: 28, carbs: 46, fat: 24 },
  { id: 'lm4', restaurant: 'Juan Valdez', name: 'Sándwich de pavo', meal: 'Snack', kcal: 390, protein: 24, carbs: 36, fat: 14 },
];

export const DEMO_BARCODE = {
  code: '7702001043211',
  name: 'Avena en hojuelas',
  meal: 'Desayuno',
  kcal: 150,
  protein: 5,
  carbs: 27,
  fat: 3,
};

export const DEMO_PHOTO_PLATE = {
  name: 'Pechuga, arroz y ensalada',
  meal: 'Almuerzo',
  grams: 320,
  kcal: 520,
  protein: 42,
  carbs: 48,
  fat: 14,
};

export const DEMO_NICO_REPLIES = {
  '¿Cómo voy con la proteína?': 'Vas en buen camino. Con lo que registraste hoy te falta un poco de proteína: un yogur griego o un huevo en la cena te acerca a la meta sin pasarte de calorías.',
  '¿Qué ceno si ya comí pollo?': 'Prueba pescado o huevos con verdura y una porción pequeña de carbohidrato. Así cierras el día sin repetir el mismo plato.',
  '¿Puedo comer fruta de noche?': 'Sí. Una fruta entera cabe bien si todavía te faltan carbohidratos. Evita el jugo: suma azúcar y no llena igual.',
};

export function demoVigencias() {
  const today = todayYmd();
  return [
    { id: 'vg1', nombre: 'María López', plan: 'BASIC', estado: 'activo', days_left: 6, valid_until: shiftYmd(today, 6) },
    { id: 'vg2', nombre: 'Juan Pérez', plan: 'INTERMEDIATE', estado: 'activo', days_left: 18, valid_until: shiftYmd(today, 18) },
    { id: 'vg3', nombre: 'Ana Ruiz', plan: 'BASIC', estado: 'inactivo', days_left: -4, valid_until: shiftYmd(today, -4) },
    { id: 'vg4', nombre: 'Laura Méndez', plan: 'ADVANCED', estado: 'revisado', days_left: 27, valid_until: shiftYmd(today, 27) },
    { id: 'vg5', nombre: 'Camilo Rojas', plan: 'BASIC', estado: 'activo', days_left: 0, valid_until: today },
  ];
}

function seedFoodAdvisees() {
  return [
    {
      id: 'fs_maria',
      firstName: 'María',
      lastName: 'López',
      email: 'maria.demo@ejemplo.com',
      trafficLight: 'GREEN',
      adherence: 86,
      lastLog: shiftYmd(todayYmd(), -1),
      weight: 68.2,
      notes: [
        { id: 'fn1', at: shiftYmd(todayYmd(), -2), text: 'Buen registro de proteína. Prioriza carbos post-entreno.' },
      ],
    },
    {
      id: 'fs_juan',
      firstName: 'Juan',
      lastName: 'Pérez',
      email: 'juan.demo@ejemplo.com',
      trafficLight: 'YELLOW',
      adherence: 54,
      lastLog: shiftYmd(todayYmd(), -4),
      weight: 81.4,
      notes: [],
    },
    {
      id: 'fs_ana',
      firstName: 'Ana',
      lastName: 'Ruiz',
      email: 'ana.demo@ejemplo.com',
      trafficLight: 'RED',
      adherence: 22,
      lastLog: null,
      weight: 64.0,
      notes: [],
    },
  ];
}

export const TRAINING_NAV = [
  { id: 'home', label: 'Inicio' },
  { id: 'advisees', label: 'Mis asesorados' },
  { id: 'routines', label: 'Rutinas' },
  { id: 'clients', label: 'Clientes' },
  { id: 'seguimiento', label: 'Seguimiento' },
];

/** Estado inicial del simulador (flujos tipo plataforma, sin BD). */
export function createInitialDemoState() {
  return {
    version: 5,
    ui: {
      screen: 'landing',
      visitorName: '',
      guideOpen: true,
      guideStep: 0,
      product: 'food',
      trainingView: 'home',
      foodPersona: 'final',
      foodView: 'dashboard',
      foodTrainerTab: 'students',
      selectedClientId: 'cli_maria',
      selectedFoodAdviseeId: 'fs_maria',
      assignRoutineId: null,
      routineDraftId: null,
      seguimientoTab: 'resumen',
      foodTrainerAction: null,
    },
    coach: {
      nombre: 'Coach Demo',
      routines: PREDESIGNED_ROUTINES.map((r) => ({ ...r, dias: r.dias.map((d) => ({ ...d })) })),
      clients: seedClients(),
    },
    foodFinal: {
      ...emptyFoodDay(),
      persona_label: 'Usuario final',
      coach_linked: false,
    },
    foodTrainer: {
      firstName: 'Alex',
      lastName: 'Entrenador',
      trainerCode: 'DEMO-FOOD-42',
      students: seedFoodAdvisees(),
      vigencias: demoVigencias(),
      localMeals: [
        { id: 'lm1', restaurant: 'El Corral', name: 'Hamburguesa El Corral' },
        { id: 'lm2', restaurant: 'Crepes & Waffles', name: 'Ensalada César' },
        { id: 'lm3', restaurant: 'Crepes & Waffles', name: 'Crepes de pollo' },
        { id: 'lm4', restaurant: 'Juan Valdez', name: 'Sándwich de pavo' },
      ],
      inbox: [
        {
          id: 'inbox1',
          from: 'María López',
          at: shiftYmd(todayYmd(), -1),
          text: 'Coach, ya registré el agua y el peso de hoy.',
          unread: true,
        },
      ],
    },
    touched_at: Date.now(),
  };
}

export function emptyRoutineDraft() {
  return {
    id: uid('tpl'),
    nombre: '',
    level: 'intermedio',
    method: 'hipertrofia',
    is_template: true,
    prediseñada: false,
    dias: [
      dayTemplate('Día 1', [
        { name: '', sets: 3, reps: '8-12', rpe: 7 },
      ]),
    ],
  };
}

export function emptyClientDraft() {
  return {
    nombre: '',
    email: '',
    telefono: '',
    plan: 'Mensual Training',
  };
}
